<div class="top-plan-view">
  <div class="title">{{ plan.name }}</div>
  <div class="price-wrapper">
    <div *ngIf="isTextPrice() then textPrice else notTextPrice"></div>
    <ng-template #textPrice>
      <div class="price">{{ getPlanPrice() }}</div>
      <div class="price-label" i18n="@@planViewOptionMonthlyLabelBelowPrice">monthly</div>
    </ng-template>
    <ng-template #notTextPrice>
      <div class="price not-fixed">{{ getPlanPrice() }}</div>
    </ng-template>
  </div>
  <div class="features">
    <div class="feature" i18n="@@planViewOptionFeature0" *ngIf="plan.name === 'Demo'">Valid for the first 15 days</div>
    <div class="feature" i18n="@@planViewOptionFeature1">Email distribution</div>
    <div class="feature"><span class="highlight">{{ getMonthlyDeliveries() }}</span><span i18n="@@planViewOptionFeature2">monthly deliveries</span></div>
    <div class="feature" *ngIf="getDailyDeliveries() !== '0' && getDailyDeliveries() !== '-1'"><span class="highlight">{{ getDailyDeliveries() }}</span><span i18n="@@planViewOptionFeature3">average daily deliveries (not limited daily)</span></div>
    <div class="feature" i18n="@@planViewOptionFeature4">Delivered in PDF or Image</div>
  </div>
</div>
<div class="bottom-plan-view">
  <div class="actions" *ngIf="plan.name !== 'Demo'">
    <button *ngIf="!isContact" class="btn btn-primary full-width" (click)="onSelectClick()" i18n="@@planViewOptionSelectButton">Select</button>
    <button *ngIf="isContact" class="btn btn-primary btn-contact full-width" (click)="onContactClick()" i18n="@@planViewOptionContactButton">Contact</button>
  </div>
</div>
